import { Products } from "modules/products";

const ProductsPage = () => {
  return <Products />;
};

export default ProductsPage;
